import { render, staticRenderFns } from "./TextEditable.vue?vue&type=template&id=65986439&"
import script from "./TextEditable.vue?vue&type=script&lang=js&"
export * from "./TextEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65986439')) {
      api.createRecord('65986439', component.options)
    } else {
      api.reload('65986439', component.options)
    }
    module.hot.accept("./TextEditable.vue?vue&type=template&id=65986439&", function () {
      api.rerender('65986439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/TextEditable.vue"
export default component.exports